$shm_hitalama_agent_map_sessions $mol_pick
	server_url \
	map_id \
	opencode_session_ids? /string
	session_id? \
	new_session_model null
	hint <= sessions_hint \Сессии карты
	trigger_content /
		<= Sessions_icon $mol_icon_chat
	bubble_content /
		<= Content $mol_view
			sub /
				<= New_session $mol_button_major
					sub /
						<= New_session_icon $mol_icon_plus
						\Новая сессия
					click? <=> new_session? null
				<= Sessions $mol_list
					rows <= session_rows /
	Session_row* $mol_button_minor
		title <= session_title* \
		attr *
			^
			selected <= session_current* false
		click? <=> session_select*? null
